export interface ErrorFromApi {
    isForHumans?: boolean;
    message?: string;
    errors?: { [key: string]: string[] | string } | string;
}

export class ErrorExtractor {
    extractErrors(genericError: string, error: ErrorFromApi, status?: number): string[] {
        const errors: string[] = [];

        if (error) {
            if (!error.isForHumans) {
                // If the error is not for human, display a global error
                errors.push(status ? `${genericError} (${status})` : genericError);
            } else if (typeof error.errors === 'string' || error.errors instanceof String) {
                // Sometimes, the api returns a string instead of an object
                errors.push(new String(error.errors).toString());
            } else if (error.errors) {
                // Else, loop through all the errors and add them to be displayed
                for (const key in error.errors) {
                    if (Object.prototype.hasOwnProperty.call(error.errors, key)) {
                        const element = error.errors[key];

                        // The error can be an array or a string [ErrorFromApi]
                        Array.isArray(element) ? errors.push(...element) : errors.push(element);
                    }
                }
            } else if (error.message) {
                errors.push(error.message);
            }
        }

        return errors;
    }
}
